'use client';

import { recoverToHome } from '@/lib/recoverToHome';
import { useEffect, useMemo, useState } from 'react';

type ModalState =
  | {
      open: true;
      count: number;
      reason: string;
    }
  | { open: false };

export default function AppRecoverModalHost() {
  const [state, setState] = useState<ModalState>({ open: false });

  useEffect(() => {
    const onModal = (event: Event) => {
      const e = event as CustomEvent<{ count?: number; reason?: string }>;
      setState({
        open: true,
        count: Number(e.detail?.count || 3),
        reason: String(e.detail?.reason || 'unknown'),
      });
    };
    window.addEventListener('hzc:recover:modal', onModal as EventListener);
    return () => window.removeEventListener('hzc:recover:modal', onModal as EventListener);
  }, []);

  const title = useMemo(() => {
    if (!state.open) return '';
    return 'Geçici bir sorun olabilir';
  }, [state]);

  if (!state.open) return null;

  return (
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl p-6">
        <div className="text-lg font-semibold text-gray-900">{title}</div>
        <div className="mt-2 text-sm text-gray-600">
          Uygulama birkaç kez üst üste kendini yenilemek zorunda kaldı. İstersen ana sayfaya dönelim ya da tekrar
          deneyelim.
        </div>

        <div className="mt-4 flex flex-col gap-2">
          <button
            type="button"
            className="w-full rounded-lg bg-hzc_purple_500 text-white py-3 font-medium hover:bg-hzc_purple_600 transition-colors"
            onClick={() => recoverToHome('unknown', { force: true })}
          >
            Tekrar dene
          </button>
          <button
            type="button"
            className="w-full rounded-lg bg-gray-100 text-gray-800 py-3 font-medium hover:bg-gray-200 transition-colors"
            onClick={() => {
              setState({ open: false });
              recoverToHome('unknown', { force: true });
            }}
          >
            Ana sayfaya dön
          </button>
        </div>

        <div className="mt-4 text-xs text-gray-400">
          Deneme: {state.count} • Kod: {state.reason}
        </div>
      </div>
    </div>
  );
}

